const urls = {
  UrlFacebook: "https://web.facebook.com/pham.chien.880758",
  UrlGithub: "https://github.com/benphamdev",
};

export default urls;
